import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44b40959")

_pushScopeId("data-v-44b40959")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Server settings", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "mmApiUrl"
}, "Mattermost API URL", -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "help" }, "eg. https://mattermost.server/api/v4", -1)
const _hoisted_9 = { class: "field mt-5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "mmApiAccessToken"
}, " Mattermost API access token ", -1)
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "field mt-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "mmBotId"
}, "Mattermost Bot ID", -1)
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "field mt-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "mmInfoChannelId"
}, " Mattermost info channel ID ", -1)
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "field mt-5" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "mmDailyChannelId"
}, " Mattermost daily channel ID ", -1)
const _hoisted_20 = { class: "control" }
const _hoisted_21 = { class: "field mt-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "webAppUrl"
}, " Web app URL ", -1)
const _hoisted_23 = { class: "control" }
const _hoisted_24 = { class: "field mt-5" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "title mt-6" }, "Daily status", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
        class: "form"
      }, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "mmApiUrl",
              type: "url",
              placeholder: "URL",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mattermostApiUrl = $event)),
              disabled: _ctx.isLoading,
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.mattermostApiUrl]
            ])
          ]),
          _hoisted_8
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "mmApiAccessToken",
              type: "password",
              placeholder: "Access token",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mattermostApiAccessToken = $event)),
              disabled: _ctx.isLoading,
              minlength: "26",
              maxlength: "26",
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.mattermostApiAccessToken]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "mmBotId",
              type: "text",
              placeholder: "Bot ID",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mattermostBotId = $event)),
              disabled: _ctx.isLoading,
              minlength: "26",
              maxlength: "26",
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.mattermostBotId]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "mmInfoChannelId",
              type: "text",
              placeholder: "Info channel ID",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mattermostInfoChannelId = $event)),
              disabled: _ctx.isLoading,
              minlength: "26",
              maxlength: "26",
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.mattermostInfoChannelId]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "mmDailyChannelId",
              type: "text",
              placeholder: "Info channel ID",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mattermostDailyChannelId = $event)),
              disabled: _ctx.isLoading,
              minlength: "26",
              maxlength: "26",
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.mattermostDailyChannelId]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("div", _hoisted_23, [
            _withDirectives(_createVNode("input", {
              class: "input",
              id: "webAppUrl",
              type: "url",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.webAppUrl = $event)),
              disabled: _ctx.isLoading,
              placeholder: "Web app URL",
              required: ""
            }, null, 8, ["disabled"]), [
              [_vModelText, _ctx.webAppUrl]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("p", _hoisted_25, [
            _createVNode("button", {
              class: ["button is-link", { 'is-loading': _ctx.isUpdating }]
            }, " Save ", 2)
          ])
        ])
      ], 32),
      _hoisted_26,
      _hoisted_27,
      _createVNode("button", {
        class: "button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendDailyStatus && _ctx.sendDailyStatus(...args)))
      }, "Send daily status")
    ])
  ]))
})